import { SearchFilter } from '@interfaces/search-filter.model';

export type SettingsFiltersState = {
  filters: SearchFilter[];
  appliedFilters?: SearchFilter[];
  loading?: boolean;
};

export const initialState: SettingsFiltersState = { filters: [] };
